import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BRAND_LABEL } from "../config/branding";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const navLinks = [
    { label: "About", to: "/#about" },
    { label: "Services", to: "/#services" },
    { label: "Programs", to: "/#programs" },
    { label: "Projects", to: "/#projects" },
    { label: "Events", to: "/events" },
    { label: "Blog", to: "/blog" },
    { label: "Contact", to: "/#contact" },
  ];

  const isActive = (to) => {
    if (to.startsWith("/#")) {
      return location.pathname === "/" && location.hash === to.slice(1);
    }

    if (to === "/blog") {
      return location.pathname.startsWith("/blog");
    }

    return location.pathname === to;
  };

  return (
    <nav className="fixed top-0 left-0 z-50 w-full border-b border-[#111712]/10 bg-[#eeeee8]/90 text-[#111712] backdrop-blur-md">
      <div className="mx-auto max-w-7xl px-5 py-3 sm:px-8 md:px-12">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" aria-label="JisedAI home">
            <img
              src="/jisedai-orbit-logo.png"
              alt={`${BRAND_LABEL} Logo`}
              className="h-8 w-8 rounded-full object-cover md:h-9 md:w-9"
            />
            <span className="text-sm font-bold tracking-[-0.03em]">{BRAND_LABEL}</span>
          </Link>

          <button
            type="button"
            className="inline-flex items-center justify-center rounded-xl border border-[#111712]/15 p-2 text-[#111712] transition hover:border-[#111712]/40 md:hidden"
            onClick={() => setIsOpen((open) => !open)}
            aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={isOpen}
          >
            {isOpen ? <X size={22} /> : <Menu size={22} />}
          </button>

          <div className="hidden items-center gap-6 text-xs font-bold uppercase tracking-[0.08em] md:flex">
            {navLinks.map((item) =>
              <Link
                key={item.label}
                to={item.to}
                className={`transition ${
                  isActive(item.to)
                    ? "text-[#45695a]"
                    : "hover:text-[#45695a]"
                }`}
              >
                {item.label}
              </Link>
            )}
          </div>
        </div>

        <div
          className={`overflow-hidden transition-all duration-300 md:hidden ${
            isOpen ? "max-h-96 pt-4" : "max-h-0"
          }`}
        >
            <div className="rounded-2xl border border-[#111712]/15 bg-[#eeeee8] p-4 shadow-xl shadow-black/10">
            <div className="flex flex-col gap-1 text-sm font-medium">
              {navLinks.map((item) =>
                <Link
                  key={item.label}
                  to={item.to}
                  className={`rounded-xl px-4 py-3 transition ${
                    isActive(item.to)
                      ? "bg-[#d6e85c]/50 text-[#111712]"
                      : "hover:bg-[#111712]/5 hover:text-[#45695a]"
                  }`}
                >
                  {item.label}
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
